export const state = () => ({
  showLoginPop: false,
  serverList: [],
  levelConf: {},

  // 重置页面时需要隐藏的模块
  resetPageHideComponent: [],
  // 充值模块隐藏类型 0:默认无 1:隐藏[topMenu]
  hideRechargeType: 0
})

export const getters = {
  serverList: (state) => state.serverList,
  resetPageHideComponent: (state) => state.resetPageHideComponent,
  hideRechargeType: (state) => state.hideRechargeType
}

export const mutations = {
  setLoginPop(state, flag) {
    state.showLoginPop = flag
  },
  setServerList(state, list) {
    state.serverList = list || []
  },
  updateState(state, [key, value]) {
    state[key] = value
  },
  initHideRechargeComponent(state, hideComponent) {
    state.resetPageHideComponent = hideComponent
  },
  setHideRechargeType(state, hideRechargeType) {
    state.hideRechargeType = hideRechargeType
  }
}

export const actions = {
  getServerList({ state, commit }) {
    if (state.serverList.length) {
      return Promise.resolve(state.serverList)
    }
    return this.$request('cateServerList', {
      body: { code_sort: 'sort' }
    }).then((arr = []) => {
      const data = arr.map((e, i) => ({ ...e, index: i }))
      commit('setServerList', data)
      return data
    })
  },
  getLevelConf({ state, commit }) {
    if (state.levelConf.vip1) return state.levelConf
    return this.$axios(
      'https://static2-youxi.a.88cdn.com/config/vip-level-conf-prod.json?_t=' +
        Date.now()
    ).then((rep) => {
      commit('updateState', ['levelConf', rep.data])
    })
  },
  // 初始化充值模块内组件的显示隐藏
  initHideRechargeComponent({ state, commit }, rechargeType) {
    commit(
      'initHideRechargeComponent',
      [
        [],
        // 原始传奇内嵌充值页
        [
          'topMenu' // 顶部菜单
        ]
      ][rechargeType] || []
    )
  }
}
